import type { HookFormSubmitHandler } from 'common/models';
import { ErrorAlert } from 'components';
import { FormError, FormWrapper, SubmitButton, TextInput } from 'components/forms/hook-form';
import { useCustomTranslation } from 'helpers/translationHelper';
import { useValidators } from 'helpers/validation';

interface Props {
  refreshTokenFailed: boolean;
  onSubmit: HookFormSubmitHandler<LoginFormValues>;
}

export interface LoginFormValues {
  username: string;
  password: string;
}

const LoginForm = ({ onSubmit, refreshTokenFailed }: Props) => {
  const { t } = useCustomTranslation();
  const validators = useValidators();

  const defaultValues: LoginFormValues = {
    password: '',
    username: ''
  };

  return (
    <FormWrapper defaultValues={defaultValues} onSubmit={onSubmit}>
      <TextInput
        label={t('login.forms.usernameLabel')}
        name="username"
        required
        options={{ required: validators.required }}
        autoComplete="username"
      />
      <TextInput
        label={t('login.forms.passwordLabel')}
        name="password"
        type="password"
        required
        options={{ required: validators.required }}
        autoComplete="current-password"
      />
      <FormError />
      {refreshTokenFailed ? <ErrorAlert errorCode="expired" newTranslate /> : null}
      <SubmitButton label={t('login.forms.loginButton')} className="public-btn" ignoreDirtyCheck />
    </FormWrapper>
  );
};

export default LoginForm;
